// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__EGtGs","footer":"ModalCreateQualiphyProcedure_footer__1-L4F","additionData":"ModalCreateQualiphyProcedure_additionData__3pInA"};